// import Backbone from 'backbone'
import {EventEmitter} from 'events'

// const BasicLiveChannel = Backbone.Model.extend({
class BasicLiveChannel extends EventEmitter {

  constructor(opts) {
    super(...arguments)
    this.isStarted = false
    this.io = opts.io
    if (opts.channelUrl) {
      this.channelUrl = opts.channelUrl
    }
    if (opts.onDataChanged) {
      this.onDataChanged = opts.onDataChanged
    }
    this.eventName = opts.eventName ? opts.eventName : 'event'
    this.channelOptions = {
      upgrade: true,
      transports: ['websocket']
    }
  }

  start() {
    if (!this.isStarted) {
      this.isStarted = true
      // this.socket = this.io.connect('ws://' + this.channelUrl, this.channelOptions)
      this.socket = this.io.connect(this.channelUrl, this.channelOptions)
      if (this.onDataChanged) {
        this.socket.on(this.eventName, this.onDataChanged.bind(this))
      }
    }
  }

  // Extend with onDataChanged method override, or pass one as init options
  // onDataChanged(socketData) {
  //   return socketData
  // }

  sendData(data, eventName) {
    this.socket.emit(eventName || this.eventName, data)
    return
  }
}

export default BasicLiveChannel
